import { INTERPOLATION_REGEX, DEALERID_QUERY_PARAM } from '../../core/constants';
import { getFormattedStartDate, getFormattedEndDate } from '../../core/selectors/offers';
import { getCurrentZipcode } from '../../core/selectors/zipcode';
import { getQueryString } from '../../core/utils/formatter';
import { findParam } from '../../core/queryParams';
import { OFFERS } from '../../core/selectors/constants';
import { getOfferTerm, getMonthsBetween } from '../../core/helpers/offers';
riot.tag2('offer-detail-container', '<div class="offer-detail-content"> <div class="offer-detail-box"> <span class="offer-detail-box-label acr-label-3"> {getLabel(\'labels.offerDetails.availableDates\')} </span> <span class="offer-detail-box-copy acr-label-3"> {formattedStartDate}{getLabel(\'labels.offerDetails.dateSeparator\')}{formattedEndDate} </span> </div> <div class="offer-detail-description acr-paragraph-7" if="{cleanText(opts.offer.SpecialDescription)}"> <raw-html content="{cleanText(opts.offer.SpecialDescription)}"></raw-html> </div> <div class="offer-detail-description acr-paragraph-7" if="{cleanText(opts.offer.TermsAndConditions)}"> <raw-html content="{cleanText(opts.offer.TermsAndConditions)}"></raw-html> </div> </div> <div class="offer-detail-ctas-container"> <a each="{link, index in getLabel(\'ctas.offerDetailsButtons\')}" if="{parent.opts.offer.SalesProgramType === OFFERS.TYPES.HCPV && link.style.indexOf(OFFERS.TYPES.HCPV) !== -1}" href="{link.modal? null : getURL(link)}" onclick="{link.modal? () => getRaqEvent(link) : null}" target="{link.target}" class="offer-detail-cta {link.style} acr-cta-btn {index ? \'is-dark\' : \'is-red-bg\'}" data-automation="{link.name}" data-tracking="{parent.opts.offer && getTrackingData(parent.opts.offer,trackingData.offerDetailCTAs)}"> {getText(link.name)} </a> <a each="{link, index in getLabel(\'ctas.offerDetailsButtons\')}" if="{parent.opts.offer.SalesProgramType !== OFFERS.TYPES.HCPV && link.style.indexOf(OFFERS.TYPES.HCPV) === -1}" href="{link.modal? null : getURL(link)}" onclick="{link.modal? () => getRaqEvent(link) : null}" target="{link.target}" class="offer-detail-cta {link.style} acr-cta-btn {index ? \'is-dark\' : \'is-red-bg\'}" data-automation="{link.name}" data-tracking="{parent.opts.offer && getTrackingData(parent.opts.offer,trackingData.offerDetailCTAs)}"> {getText(link.name)} </a> </div> <div class="offer-detail-ctas-container"> <a each="{link, index in getLabel(\'ctas.offerDetailsLinks\')}" if="{parent.opts.offer.SalesProgramType === OFFERS.TYPES.HCPV && link.style.indexOf(OFFERS.TYPES.HCPV) !== -1}" href="{getURL(link)}" target="{link.target}" class="offer-detail-cta-text {link.style} acr-cta-text" data-automation="{link.name}" data-tracking="{parent.opts.offer && getTrackingData(parent.opts.offer,trackingData.offerDetailLinks)}"> <span>{getText(link.name)}</span> </a> <a each="{link, index in getLabel(\'ctas.offerDetailsLinks\')}" if="{parent.opts.offer.SalesProgramType !== OFFERS.TYPES.HCPV && link.style.indexOf(OFFERS.TYPES.HCPV) === -1}" href="{getURL(link)}" target="{link.target}" class="offer-detail-cta-text {link.style} acr-cta-text" data-automation="{link.name}" data-tracking="{parent.opts.offer && getTrackingData(parent.opts.offer,trackingData.offerDetailLinks)}"> <span>{getText(link.name)}</span> </a> </div>', '', 'class="offer-detail-container"', function(opts) {

    const self = this;
    const trackingJSON = require('../../data/tracking-data');

    self.trackingData = trackingJSON.default;
    self.mixin('bus');
    self.mixin('redux');

    self.subscribe(getFormattedStartDate);
    self.subscribe(getFormattedEndDate);
    self.subscribe(getCurrentZipcode);

    self.OFFERS = OFFERS;

    function getTrackingData(offer, obj) {
      const jsonData = JSON.parse(JSON.stringify(obj));
      jsonData.Offer.offer_type = offer.type;
      jsonData.Model = {
        model_name: offer.ModelGroupName,
        model_year: offer.ModelYear ? offer.ModelYear.toString() : '',
      };
      jsonData.Offer.offer_amount = offer.payment;
      jsonData.Offer.offer_name = offer.SalesProgramName;
      jsonData.Offer.offer_date = `${offer.StartDate} | ${offer.EndDate}`;
      jsonData.Offer.offer_model = offer.ModelGroupName;
      jsonData.Offer.offer_model_year = offer.ModelYear ? offer.ModelYear.toString() : '';
      jsonData.Offer.offer_duration = getMonthsBetween(offer.StartDate, offer.EndDate);
      jsonData.Offer.offer_term = getOfferTerm(offer);
      jsonData.Offer.offer_expire = offer.EndDate;
      jsonData.Offer.offer_start = offer.StartDate;
      jsonData.Offer.offer_id = offer.Id;
      jsonData.dynamic_variables[0].search += `${jsonData.Offer.offer_name} [click text]`;
      return JSON.stringify(jsonData);
    }

    function getText(name) {
      const dataObj = {
        modelgroupname: self.opts.offer.ModelGroupName,
        modelgroupnamewithhypens: self.opts.offer.ModelGroupName.toLowerCase().replace(' ', '-'),
        modelgroupnamewithspaces: self.opts.offer.ModelGroupName.toLowerCase(),
        offerid: self.opts.offer.Id,
        modelid: self.opts.offer.ModelId,
        modelyear: self.opts.offer.ModelYear,
        zipcode: self.zipcode,
        dealerid: findParam(DEALERID_QUERY_PARAM),
      };

      const replacements = name.match(INTERPOLATION_REGEX);

      if (replacements) {
        replacements.forEach((match) => {
          name = name.replace(match, dataObj[match.slice(3, -3).toLowerCase()] || '');
        });
      }

      return name;
    }

    function cleanText(text) {
      text = text.replace('®', '<sup>&reg;</sup>');

      return text;
    }

    function getURL(link) {
      const dataObj = {
        modelgroupname: self.opts.offer.ModelGroupName,
        modelgroupnamewithhypens: self.opts.offer.ModelGroupName.toLowerCase().replace(' ', '-'),
        modelgroupnamewithspaces: self.opts.offer.ModelGroupName.toLowerCase(),
        offerid: self.opts.offer.Id,
        modelid: self.opts.offer.ModelId,
        modelyear: self.opts.offer.ModelYear,
        zipcode: self.zipcode,
        dealerid: findParam(DEALERID_QUERY_PARAM),
      };

      const url = getText(link.url);
      const qStr = getQueryString(link.parameters, dataObj);

      return `${url}${qStr}`;
    }

    function getRaqEvent(link) {
      if (link.modal) {
        const dataObj = {
          modelgroupname: self.opts.offer.ModelGroupName,
          offerid: self.opts.offer.Id,
          modelid: self.opts.offer.ModelId,
          modelyear: self.opts.offer.ModelYear,
          zipcode: self.zipcode,
          dealerid: findParam(DEALERID_QUERY_PARAM),
        };
        // Add a custom event to connect Riot's Inventory app with React's RAQ app
        var customEvent = new CustomEvent('react-raq-open', {
          detail: {
            offers: [dataObj.offerid],
            source: 'offers',
            modelId: dataObj.modelid
          }
        });
        window.dispatchEvent(customEvent);
      }
    }

    self.getText = getText;
    self.cleanText = cleanText;
    self.getURL = getURL;
    self.getRaqEvent = getRaqEvent;
    self.getTrackingData = getTrackingData;
});
